import { AnyAction } from "redux";
import { SET_KPI_ENTRIES_LOADED } from "../actions/loadingKpiEntries";

export const loadingKpiEntries = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_KPI_ENTRIES_LOADED:
      return action.kpiEntriesLoaded;
    default:
      return state;
  }
};

export default loadingKpiEntries;
